import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  Permission,
  DataService,
  SharedModule,
  FormInputComponent,
  GetUserStatusQuery,
  BooleanCustomFieldConfig,
} from '@vendure/admin-ui/core';

@Component({
  selector: 'highlighted-partner-component',
  templateUrl: './highlighted-partner-component.html',
  styleUrls: ['./highlighted-partner-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule],
})
export class HighlightedPartnerComponent
  implements FormInputComponent<BooleanCustomFieldConfig>, OnInit
{
  config: BooleanCustomFieldConfig;
  readonly: boolean;
  isListInput?: boolean | undefined;
  formControl: FormControl;

  protected isAdmin = false;

  constructor(
    private dataService: DataService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.dataService.client
      .userStatus()
      .mapSingle(status => status)
      .subscribe((status: GetUserStatusQuery) => {
        this.isAdmin = status.userStatus.permissions.includes(
          Permission.SuperAdmin,
        );
        this.changeDetector.detectChanges();
      });
  }
}
